import { z } from 'zod'

export const MONTHLY = 'monthly'
export const YEARLY = 'yearly'
export const UNKNOWN = 'unknown'

export const period = z.enum([MONTHLY, YEARLY, UNKNOWN])

export const periods = Object.values(period.enum)

export type Period = z.infer<typeof period>

// t('period.monthly')
// t('period.yearly')
// t('period.unknown')
